import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cover } from './cover';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CoverService {

  constructor(private http: HttpClient) { }

  getCovers(): Observable<Cover[]> {
    return this.http.get<Cover[]>(
      `${environment.legacyRiskCoachApiBase}/InsuranceClasses/GetParentInsuranceClasses?countryId=1`,
      { headers: { 'X-Legacy': 'true' } }
    ).pipe(map(d => {
      return d.map(data => {
        return new Cover().deserialize(data);
      })
    }));
  }
}
